


<div class="container col-xxl-8 px-4 ">
  <div class="row flex-lg-row-reverse align-items-center g-5 ">
    <div class="col-10 col-sm-8 col-lg-6">
      <img src="./assets/img/terapiaFisica/imgInfo.svg" class="d-block mx-lg-auto img-fluid" alt="Bootstrap Themes" width="400" height="150" loading="lazy">
    </div>
    <div class="col-lg-6">
      <p class="fs-2 fw-bold my-0  " style="color: var(--primary-color)">Conectados</p>
      <p class="fs-2 lh-1" style="color: var(--primary-color)">con tu bienestar.</p>
      <!--      <span class="fst-italic fw-bolder" style="color: var(&#45;&#45;primary-color)">*Cobertura dentro de Guayaquil</span>-->
    </div>
  </div>
</div>
